import { useCallback, useState } from 'react';
import { YellowButton } from '@/components/button/button';
import { LoginSignupButton } from '@/components/login-signup-button/login-signup-button';
import { config } from '@/config/environment';
import {
  ExperienceFieldsFragment,
  useCreateStripeCheckoutSessionMutation,
} from '@/generated/graphql';

type BoxActionsProps = {
  experience: Pick<ExperienceFieldsFragment, 'id'>;
};

export const BoxActions = ({ experience }: BoxActionsProps) => {
  const [redirecting, setRedirecting] = useState(false);
  const [createCheckoutSession] = useCreateStripeCheckoutSessionMutation();
  const id = experience?.id;

  const handleClick = useCallback(async () => {
    if (!id) {
      return;
    }

    setRedirecting(true);
    const session = await createCheckoutSession({
      variables: {
        experienceId: id,
        cancelUrl: window.location.href,
        successUrl: `${config.baseUrl}/orders/`,
      },
    });
    const url = session?.data?.createStripeCheckoutSession?.url;
    if (url) {
      window.location.href = url;
    }
  }, [createCheckoutSession, setRedirecting, id]);

  return (
    <>
      <LoginSignupButton label="Sign up to order this Box">
        <YellowButton onClick={handleClick} loading={redirecting}>
          {redirecting ? 'Redirecting...' : 'Order Box'}
        </YellowButton>
      </LoginSignupButton>
    </>
  );
};
